
import React, { useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Navbar } from "@/components/blocks/Navbar";
import { Footer } from "@/components/blocks/footer";
import { RevealOnScroll } from "@/components/ui/reveal-on-scroll";
import { Seo } from "@/components/Seo";


const Terms = () => {
  // Add useEffect to scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const footerData = {
    logo: <img src="/lovable-uploads/c22d7cd3-d7b2-4b69-9087-2e231ebb8feb.png" alt="Quickatoo Logo" className="h-10 w-auto" />,
    brandName: "Quickatoo",
    socialLinks: [],
    mainLinks: [{
      href: "/",
      label: "Home"
    }],
    legalLinks: [{
      href: "/privacy",
      label: "Privacy"
    }, {
      href: "/terms",
      label: "Terms"
    }],
    copyright: {
      text: "© 2024 Quickatoo",
      license: "All rights reserved"
    }
  };
  
  return <>
      <Seo
        title="Terms & Conditions — Quickatoo"
        description="The terms and conditions that govern the use of Quickatoo's quoting and job management software for painting contractors."
        path="/terms"
      />
      <Navbar />

      <main className="pt-28 pb-16 px-4 max-w-4xl mx-auto min-h-screen">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
        
        <div className="space-y-6">
          <RevealOnScroll>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Agreement to Terms</h2>
              <p className="text-gray-700 dark:text-gray-300">
                By accessing or using the Quickatoo service, you agree to be bound by these Terms of Service. If you do not agree to these Terms, you may not access or use the service.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={100}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Description of Service</h2>
              <p className="text-gray-700 dark:text-gray-300">
                Quickatoo provides a digital platform for painting contractors to create estimates, manage projects, and generate professional quotes for clients.
                The service is provided on an "as is" and "as available" basis.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={200}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">User Accounts</h2>
              <p className="text-gray-700 dark:text-gray-300">
                When you create an account with us, you must provide accurate and complete information. You are responsible for safeguarding the password that you use to access the service and for any activities or actions under your password.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={300}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Payments and Subscriptions</h2>
              <p className="text-gray-700 dark:text-gray-300">
                Some aspects of the service may be provided for a fee. You will be required to select a payment plan and provide accurate billing information. By submitting such information, you grant us the right to provide the information to third parties for purposes of facilitating payment.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mt-2">
                The subscription fee for the service will be billed on a recurring basis. You may cancel your subscription at any time.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={400}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Intellectual Property</h2>
              <p className="text-gray-700 dark:text-gray-300">
                The service and its original content, features, and functionality are and will remain the exclusive property of Quickatoo and its licensors. The service is protected by copyright, trademark, and other laws.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={500}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Termination</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We may terminate or suspend your account immediately, without prior notice or liability, for any reason, including without limitation if you breach the Terms. Upon termination, your right to use the service will immediately cease.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={600}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 dark:text-gray-300">
                In no event shall Quickatoo, its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={700}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Changes to Terms</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any new terms taking effect.
              </p>
            </section>
          </RevealOnScroll>

          <RevealOnScroll delay={800}>
            <section>
              <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
              <p className="text-gray-700 dark:text-gray-300">
                If you have any questions about these Terms, please contact us at <a href="mailto:info@quickatoo.com" className="text-primary hover:underline">info@quickatoo.com</a>.
              </p>
            </section>
          </RevealOnScroll>
        </div>

        <RevealOnScroll delay={900}>
          <Button className="mt-10" asChild>
            <a href="/">Back to Home</a>
          </Button>
        </RevealOnScroll>
      </main>
      <Footer {...footerData} />
    </>;
};
export default Terms;
